// extracted by mini-css-extract-plugin
export default {"header":"tMCfJb","logo":"JkqUhD","title":"VDIMTT","back":"WvNG7l","navigation":"TkVnUN"};